/**
 * Analyzer bus — tiny module-level mailbox between the Client Analyzer
 * sampler (useLocalAnalyzer, runs at RoomPage level, 1 s cadence) and the
 * status heartbeat (use-rt-room, 5 s cadence).
 *
 * The hook writes its latest 8-item summary + device echo here; the
 * heartbeat reads them when building the StatusMsg. Plain refs — no React
 * coupling, no re-renders, trivially resettable between sessions.
 */
import type { StatusMsg } from '../lib/rt-protocol'

export type AnalyzerSummary = NonNullable<StatusMsg['sum']>

let summary: AnalyzerSummary | null = null
let outputLabel: string | null = null

export function setAnalyzerSummary(s: AnalyzerSummary): void {
  summary = s
}

export function getAnalyzerSummary(): AnalyzerSummary | null {
  return summary
}

/** RoomPage device dropdowns report the picked monitor-output label here. */
export function setOutputDeviceLabel(label: string | null): void {
  outputLabel = label
}

export function getOutputDeviceLabel(): string | null {
  return outputLabel
}

export function resetAnalyzerBus(): void {
  summary = null
  outputLabel = null
}
